export default "__VITE_ASSET__DUSZzQYE__"